<template lang="pug">
  SmartTable.table(name="on-call-picker" v-bind="table", v-model="tableData" ref="table")
    template(v-slot:default="slotProps")
      TableRow(v-bind="slotProps")
        template(v-slot:mandatoryPresence="{ columnValue, rowItem, index }")
          .icon.fs-19.icon-ptt-icons-predio-ativo.color-success(v-if="columnValue === true")
          .icon.fs-19.icon-ptt-icons-predio-inativo.color-danger(v-else)

</template>

<script>
import { datetimeToTimeString } from 'src/utils'

export default {
  name: 'OnCallTable',
  props: {
    perPage: {type: Number, 'default': 10}
  },
  data () {
    return {
      selectedOnCall: {
        index: null,
        item: null
      },
      table: {
        headerItems: [
          {column: 'nome', field: 'name', width: '0.8fr'},
          {column: 'código', field: 'code', width: '0.4fr'},
          {column: 'início', field: 'startTime', width: '0.4fr', mask: '##:##', placeholder: '00:00'},
          {column: 'fim', field: 'endTime', width: '0.4fr', mask: '##:##', placeholder: '00:00'},
          {column: 'regra de cálculo', field: 'customRules', width: '0.4fr'}
        ],
        config: {
          detailsBox: {
            openOnClickRow: false
          },
          perPage: this.perPage,
          startFocusedSearch: 'name',
          defaultSortField: 'name',
          defaultColumnSearch: 'name'
        }
      }
    }
  },
  computed: {
    tableData: {
      get () {
        return {
          selected: this.selectedOnCall,
          loading: !this.$store.state.common.oncall.items.length,
          loaded: this.$store.state.common.oncall.items
            .map(jrn => ({
              ...jrn,
              startTime: datetimeToTimeString(jrn.startTime),
              endTime: datetimeToTimeString(jrn.endTime)
            }))
        }
      },
      set ({selected}) {
        this.selectedOnCall = selected
        this.$emit('selectedOnCall', selected.item)
      }
    }
  },
  methods: {
  }
}
</script>

<style scoped>

</style>
